export default __webpack_public_path__ + "f2522e64f28e968cb4fcf9a2c39ff547.png";